import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { FlexRowSpaced } from "../../../../Common/Styles";
import UserInfo from "../../../../Common/UserInfo";
import { FollowersFollowingProps } from "./FollowersFollowing";

export const FollwerUserInfo = ({
  type,
  user,
  onClick,
  followerRef,
  onHover,
  index,
}: FollowersFollowingProps.FollwerUserInfo) => {
  const { first_name, last_name, profile_picture, headline, id } = user;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(user);
    }
  };

  return (
    <Container
      ref={followerRef}
      $gapInPx={8}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      onMouseMove={() => onHover?.(index)}
      role="button"
      aria-label={`${
        type === "followers" ? "Remove" : "Unfollow"
      } ${first_name} ${last_name}`}
    >
      <UserInfo
        {...{
          headline,
          id,
          name: first_name + " " + last_name,
          profile_picture,
        }}
        showUserInfoOnHover={false}
        key={id}
        avatarSize="Small-40"
      />
      <Components.Button
        kind="Primary"
        size="XS"
        color="Neutral"
        disabled={false}
        label={type === "followers" ? "Remove" : "Unfollow"}
        onClick={() => onClick(user)}
      />
    </Container>
  );
};

const Container = styled(FlexRowSpaced)(
  ({ theme }) => `
  border-radius: ${theme.radius["radius-xxs"].value}rem;
  padding: ${theme.spacing["spacing-2"].value}rem;
  padding-left: ${theme.spacing["spacing-4"].value}rem;
  align-items: center;
  outline: none;
  
  &:focus, &:hover {
    background-color: ${theme.Color.background.neutral.subtle.default.value};
  }
`
);
